export type GridSetSize = 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8;

export const SET_SIZE: GridSetSize = 8;
